export default __webpack_public_path__ + "static/media/indexbg.34a6f530.png";